module.exports = __webpack_public_path__ + "media/images/like_this_cmnd_back_old-a8c6abc2bb939282a601eb10e5e771d8.jpg";